import React from 'react'
import cs from 'classnames'
import './index.less'

export default function Button({
  className = '',
  onClick = () => {},
  children,
}) {
  return (
    <button
      className={
        cs({
          'light-button': true,
          [className]: true,
        })
      }
      onClick={e => {
        onClick(e)
      }}
    >
      {children}
    </button>
  )
}